
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_vdkpj_ca3pu_177",
  "item-wrapper": "awsui_item-wrapper_vdkpj_ca3pu_213",
  "group": "awsui_group_vdkpj_ca3pu_217",
  "divider": "awsui_divider_vdkpj_ca3pu_221"
};
  